import TagManager from "@sooro-io/react-gtm-module";
import { DEV_ENV } from "constants/app";

export function sendUserIdentifiedEvent(data) {
  if (DEV_ENV) return;

  try {
    TagManager.dataLayer({
      dataLayer: {
        event: "user_identified",
        user_id: String(data.userId),
        username: data.userName,
        user_role: data.userRole,
        company_name: data.companyName,
        company_id: String(data.companyId),
      },
    });
  } catch (error) {
    console.error("Failed to send GTM user identified event:", error);
  }
}

export function sendCompanySwitchEvent(data) {
  if (DEV_ENV) return;

  try {
    TagManager.dataLayer({
      dataLayer: {
        event: "switch_company",
        company_id: String(data.companyId),
        company_name: data.companyName,
      },
    });
  } catch (error) {
    console.error("Failed to send GTM company switch event:", error);
  }
}
